import React from 'react';
import PropTypes from 'prop-types';
import {Box, Container} from '@tenancy.nz/design-system';

function Section({header = undefined, leftContent, rightContent = undefined}) {
  return (
    <Container disableGutters>
      <Box
        as="section"
        sx={{
          display: 'flex',
          flexDirection: {xs: 'column', md: 'row'},
          gap: {xs: '40px', md: '40px'},
          padding: {xs: '16px 24px', md: '24px 12px'},
          width: '100%',
        }}>
        {rightContent && (
          <Box
            as="aside"
            sx={{
              order: {xs: 1, md: 2},
              maxWidth: {md: '440px'},
              width: '100%',
            }}>
            {rightContent}
          </Box>
        )}
        <Box
          sx={{
            order: {xs: 2, md: 1},
            flex: 1,
          }}>
          {header}
          <Box as="main">{leftContent}</Box>
        </Box>
      </Box>
    </Container>
  );
}

Section.propTypes = {
  header: PropTypes.node,
  leftContent: PropTypes.node.isRequired,
  rightContent: PropTypes.node,
};

export default Section;
